<template>
  <div class="inline-block relative">
    <input :id="inputId"
           :name="name"
           :type="actualType"
           :disabled="disabled"
           :readonly="readOnly"
           :value="option.value"
           @input="controlInputChange"
           :checked="checked"
           class="absolute opacity-0" />
    <label v-if="option.label" :for="inputId" :class="['grid gap-2 control-label', { 'opacity-50 cursor-not-allowed': disabled }]" style="grid-template-columns: auto 1fr;">
      <span :class="['block w-5 h-5 relative border-2 border-gray-200 overflow-hidden hover:cursor-pointer', { 'rounded-md': actualType === 'checkbox' }, { 'rounded-full': actualType === 'radio' }, { '!cursor-not-allowed': disabled }]">
        <span class="hidden w-full h-full bg-primary control-indicator" :class="[{ 'control-indicator--radio': actualType === 'radio' }]">
          <svg v-if="actualType === 'checkbox'" xmlns="http://www.w3.org/2000/svg" class="w-full h-full">
              <use :href="iconHref('tick')" />
          </svg>
        </span>
      </span>

      <span class="block">{{ option.label }}</span>
    </label>
  </div>
</template>

<script>
  import IconTick from '../../../../../assets/icons/tick.svg'
  
  const iconMap = {
    'tick': IconTick
  }
  
  export default {
    name: 'IntControlField',

    emits: ["update:checked"],
  
    props: {
      type: {
        type: String, default: 'checkbox',
        validator(val) {
          return ['checkbox', 'radio', 'toggle'].includes(val)
        },
      },
      name: { type: String },
      checked: { type: Boolean },
      option: { type: Object },
      disabled: { type: Boolean, default: null },
      readOnly: { type: Boolean, default: null },
      autocomplete: { type: String },
      id: { type: String }
    },
  
    computed: {
      inputId() {
        if (this.id) return this.id
        return `control-${this._uid}`
      },
      
      actualType() {
        return this.type === 'radio' ? this.type : 'checkbox'
      }
    },
  
    methods: {
      iconHref(key) {
        if (iconMap[key]) return '#' + iconMap[key].id
        return null
      },
      
      controlInputChange(event) {
        this.$emit('update:checked', event.target.checked)
      }
    }
  }
</script>

<style scoped>
  input:checked ~ label .control-indicator {
    display: block;
  }
  
  .control-indicator--radio {
    transform: scale(0.7);
    border-radius: 50%;
  }
</style>